<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="用户姓名：" prop="userName">
            <el-input v-model="query.userName" placeholder="请输入用户姓名" size="small" clearable />
          </el-form-item>
          <el-form-item label="用友编码：" prop="yongYouCode">
            <el-input v-model="query.yongYouCode" placeholder="请输入用友编码" size="small" clearable />
          </el-form-item>
          <el-form-item label="手机号：" prop="phone">
            <el-input v-model="query.phone" placeholder="请输入手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.CLevel" placeholder="请选择" clearable size="small">
              <el-option :label="item.name" :value="item.level" v-for="item in sectionList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否查询异常账户：" v-if="activeName!='0'">
            <el-select v-model="query.isException" placeholder="请选择" clearable size="small">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-box" style="text-align: right;">
        <el-button type="primary" size="mini" @click="handleDownload1" plain>下载钱包模板</el-button>
        <el-upload v-hasPermi="['meeting:record:import']" style="display: inline-block;margin:0 5px" :action="uploadImgUrl" :show-file-list="false" :http-request="uploadFile" :file-list="fileList">
          <el-button size="mini" type="primary">导入旧系统账户</el-button>
        </el-upload>
        <el-button type="primary" size="mini" @click="handleDownload" plain v-hasPermi="['finance:account:export']">导出账户</el-button>
        <el-button type="primary" size="mini" @click="handleRefundDetailDownload" plain v-hasPermi="['finance:account:export']">导出客户退款明细</el-button>
        <el-button type="info" size="mini" @click="handleCreate(0)" icon="el-icon-minus" v-hasPermi="['finance:account:deduction']">扣减额度</el-button>
        <el-button type="primary" size="mini" @click="handleCreate(1)" icon="el-icon-plus" v-hasPermi="['finance:account:gift']">赠送额度</el-button>
        <el-button type="primary" size="mini" @click="handleEntryExit" icon="el-icon-plus" v-hasPermi="['finance:account:gift']">出入账调整</el-button>
     
        <!-- <el-button type="info" size="mini" @click="handleCreate(0)" icon="el-icon-minus" v-hasPermi="['finance:account:deduction']">扣减额度（新）</el-button>
        <el-button type="primary" size="mini" @click="handleCreate(1)" icon="el-icon-plus" v-hasPermi="['finance:account:gift']">赠送额度（新）</el-button> -->
      </div>
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="佣金" name="0"></el-tab-pane>
          <el-tab-pane label="余额账户" name="1"></el-tab-pane>
          <el-tab-pane label="零售价账户" name="2"></el-tab-pane>
          <el-tab-pane label="赠送账户" name="3"></el-tab-pane>
          <el-tab-pane label="积分" name="4"></el-tab-pane>
        </el-tabs>

      </div>
      <div class="font14 c-danger mb20" v-if="activeName=='1' && info.balance">账户异常：{{info.balance}}</div>
      <div class="font14 c-danger mb20" v-if="activeName=='2' && info.xiaodu_money">账户异常：{{info.xiaodu_money}}</div>
      <div class="font14 c-danger mb20" v-if="activeName=='3' && info.tuition">账户异常：{{info.tuition}}</div>
      <el-table v-loading="listLoading" :data="list" height="500" :key="activeName">
        <el-table-column label="钱包id" prop="userWalletId" align="center" fixed />
        <el-table-column label="用户名称" prop="name" align="center" fixed>
        </el-table-column>
        <el-table-column label="手机号" prop="pho" align="center" fixed />
        <el-table-column label="用友编码" prop="yonyouCode" align="center" />
        <el-table-column label="银行卡名称" prop="bankName" align="center" v-if="activeName=='0'" />
        <el-table-column label="银行卡" prop="cardNumber" align="center" v-if="activeName=='0'" />
        <el-table-column label="身份" prop="levelName" align="center" />
        <el-table-column label="负责区域" prop="" align="center" v-if="activeName=='0'">
          <template slot-scope="{row}">
            <div @click="showArea(row,row.areaCount)">
              <el-link type="primary">{{row.areaCount}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="佣金剩余账户" prop="commissionMoney" align="center" v-if="activeName=='0'" />
        <el-table-column label="已提现金额" prop="withdrawalAmount" align="center" v-if="activeName=='0'" />
        <el-table-column label="余额剩余" prop="balance" align="center" v-if="activeName=='1'" />
        <el-table-column label="零售价剩余" prop="xiaoduMoney" align="center" v-if="activeName=='2'" />
        <el-table-column label="赠送剩余" prop="tuition" align="center" v-if="activeName=='3'" />
        <el-table-column label="剩余积分" prop="integral" align="center" v-if="activeName=='4'" />
        <el-table-column label="操作" align="center" fixed="right" width="160">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShowDetail(row)">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <account-add ref="accountAdd" @created="doQueryList({})" :popType="popType" :reasonOptions="reasonOptions" />
    <el-dialog title="管辖区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <div class="dialog-box">
        <el-tree :data="areaOptions" :props="defaultProps"></el-tree>
      </div>
    </el-dialog>
    <entry-exit-vue ref="entryExitVue" @created="doQueryList({})" :reasonOptions="reasonOptions" />
  </div>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'
import sysDeptApi from '@/api/sys/sysDept'
import Pagination from '@/components/Pagination'
import userApi from '@/api/sys/user'
import accountAdd from './add'
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
import clientAreaApi from '@/api/client/clientArea'
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
import userWalletApi from '@/api/sys/userWallet'
import { filterEmpty } from '@/utils'
import entryExitVue from './entryExit.vue'
export default {
  components: {
    Pagination,
    accountAdd,
    entryExitVue
    // businessQuit,
    // businessAdjust,
    // areaRemove
  },
  data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
      popType: null,
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      sectionList: [],
      dateTime: null,
      activeName: '0',
      info: {},
      areaOptions: [],
      formVisible: false,
      defaultProps: {
        children: 'child',
        label: 'areaName'
      },
      clientOption: [],
      reasonOptions: []
    }
  },
  created() {
    this.doQueryList({
      pageNo: 1
    })
    this.getStatisticsInfo()
    this.getReasonOption()
    // this.getOption()
    this.sectionList = JSON.parse(localStorage.getItem('levelList'))
  },
  methods: {
    handleEntryExit() {
      this.$refs.entryExitVue.handleCreate()
    },
    getReasonOption() {
      sysGiftAccountReasonApi.findOption().then(({
        data
      }) => {
        if (data) {
          this.reasonOptions = data
        }
      })
    },
    showArea(customer, num) {
      if (!num) return
      this.changeIdentity(customer)
    },
    // 获取区域列表
    changeIdentity(customer) {
      let obj = {}
      obj.customerId = customer.customerId
      obj.v = 3
      obj.addOrDelete = 2
      obj.parentCustomerId = customer.parentId;
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      clientAreaApi.fetchTreeList(obj).then(({
        data
      }) => {
        this.loading.close()
        if (data) {
          this.areaOptions = data
          this.formVisible = true
        }
      }).catch(() => {
        this.loading.close()
      })
    },

    async getStatisticsInfo() {
      const {
        data
      } = await managecustomerwalletApi.getStatistics()
      this.info = data
      console.log('统计: ', data);
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    async doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query,
      }
      if (this.dateTime && this.dateTime.length) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      if (this.activeName != '0') {
        query.type = this.activeName * 1
      } else {
        query.isException = undefined
      }

      this.listLoading = true
      const {
        data
      } = this.activeName == '0' ? await managecustomerwalletApi.fetchList(filterEmpty(query)) : await managecustomerwalletApi.fetchListPage(filterEmpty(query))
      this.list = data.list
      this.total = data.total
      console.log('data: ', data);
      this.listLoading = false
    },
    /**
     * 打开新建、编辑表单
     */
    handleCreate(type) {
      this.popType = type
      this.$refs.accountAdd.handleCreate()
    },
    //查看信息
    handleShowDetail(row) {
      if (this.dateTime && this.dateTime.length) {
        row.queryStartTime = this.dateTime[0]
        row.queryEndTime = this.dateTime[1]
      }
      this.$emit('handleShow', { row, activeType: this.activeName * 1 }, 2)
    },
    handleDownload() {
      this.$router.push("/export/list?code=manageFinanceAccountDownloadExcel")
    },
    handleRefundDetailDownload() {
      this.$router.push("/export/list?code=manageFinanceRefundDetailDownloadExcel")
    },
    handleDownload1() {
      userWalletApi.exportExcel()
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      userWalletApi.importExceltemplate(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.dialog-box {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
